import { ComponentSingleStyleConfig } from "@chakra-ui/react";

export const popoverTheme: ComponentSingleStyleConfig = {
  baseStyle: {
    content: {
      borderColor: "gray.300",
      boxShadow: "md",
    },
  },
};
